<template>
  <div v-if="captain">
   <sala/>
  </div>
  <div v-else>
    <cashier/>
  </div>
</template>

<script>
import cashier from "./Cashier.vue";
import sala from "./Sala.vue";

export default {
  name:"Home",
  components: {
    cashier,
    sala,
   
  },

 
  computed: {
   
      captain() {
      let user = localStorage.getItem("heavenDashboardUser");
      if (JSON.parse(user).role_id == 4) {
        return true;
      } else {
        return false;
      }
    },
      salaCashier() {
      let user = localStorage.getItem("heavenDashboardUser");
      if (JSON.parse(user).role_id == 2) {
        return true;
      } else {
        return false;
      }
    },
  },
  
};
</script>
